import * as THREE from 'three'
import { gsap } from 'gsap'

export default class Audio
{
    constructor( experience )
    {
        this.experience = experience
        this.camera = this.experience.camera.instance
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.debug = this.experience.debug
        this.models = this.experience.world.models

        this.params = {
            audioEnabled: true,
            masterVolume: 0,
            speakersVisible: false,
            audioHelper: true,
        }

        this.setup()
        this.setFPAudio()
        this.setDebug()
    }

    setup()
    {
        this.speakerGeo = new THREE.BoxGeometry( 0.4, 0.4, 0.4 )
        this.speakerMat = new THREE.MeshBasicMaterial({color:'#ffffff', visible: this.params.speakersVisible})
        this.audioChanging = false
    }

    // set first person audio
    setFPAudio()
    {
        this.listener = new THREE.AudioListener()
        this.listener.getMasterVolume()
        this.listener.setMasterVolume(this.params.masterVolume)

        this.footstep1 = new THREE.PositionalAudio( this.listener )
        this.footstep1.setBuffer(this.resources.items.footstep1)
        this.footstep1.setRefDistance(1)
        this.footstep1.setRolloffFactor(1)
        this.footstep1.setLoop(false)
        this.footstep1.setVolume(1)

        this.footstep2 = new THREE.PositionalAudio( this.listener )
        this.footstep2.setBuffer(this.resources.items.footstep2)
        this.footstep2.setRefDistance(1)
        this.footstep2.setRolloffFactor(1)
        this.footstep2.setLoop(false)
        this.footstep2.setVolume(1)

        this.footstep3 = new THREE.PositionalAudio( this.listener )
        this.footstep3.setBuffer(this.resources.items.footstep3)
        this.footstep3.setRefDistance(1)
        this.footstep3.setRolloffFactor(1)
        this.footstep3.setLoop(false)
        this.footstep3.setVolume(1)

        this.footstep4 = new THREE.PositionalAudio( this.listener )
        this.footstep4.setBuffer(this.resources.items.footstep4)
        this.footstep4.setRefDistance(1)
        this.footstep4.setRolloffFactor(1)
        this.footstep4.setLoop(false)
        this.footstep4.setVolume(1)

        this.bootUp = new THREE.PositionalAudio( this.listener )
        this.bootUp.setBuffer(this.resources.items.bootUp)
        this.bootUp.setRefDistance(1)
        this.bootUp.setRolloffFactor(1)
        this.bootUp.setLoop(false)
        this.bootUp.setVolume(0.05)

        this.rain = new THREE.PositionalAudio( this.listener )
        this.rain.setBuffer(this.resources.items.rain)
        this.rain.setRefDistance(1)
        this.rain.setRolloffFactor(1)
        this.rain.setLoop(true)
        this.rain.setVolume(0.07)

        this.wood = new THREE.PositionalAudio( this.listener )
        this.wood.setBuffer(this.resources.items.wood)
        this.wood.setRefDistance(0.3)
        this.wood.setRolloffFactor(1)
        this.wood.setLoop(true)
        this.wood.setVolume(1)

        this.archSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.archSpeaker)
        this.archSpeaker.position.set(this.models.archSpeaker.position.x, this.models.archSpeaker.position.y, this.models.archSpeaker.position.z)
        this.archSpeaker.add(this.wood)

        // this.water = new THREE.PositionalAudio( this.listener )
        // this.water.setBuffer(this.resources.items.water)
        // this.water.setRefDistance(0.1)
        // this.water.setRolloffFactor(1)
        // this.water.setLoop(true)
        // this.water.setVolume(1)

        // this.fountainSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        // this.scene.add(this.fountainSpeaker)
        // this.fountainSpeaker.position.set(this.models.fountainSpeaker.position.x, this.models.fountainSpeaker.position.y, this.models.fountainSpeaker.position.z)
        // this.fountainSpeaker.add(this.water)

        this.windowRain = new THREE.PositionalAudio( this.listener )
        this.windowRain.setBuffer(this.resources.items.windowRain)
        this.windowRain.setRefDistance(0.5)
        this.windowRain.setRolloffFactor(2)
        this.windowRain.setLoop(true)
        this.windowRain.setVolume(1.2)

        this.windowSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.windowSpeaker)
        this.windowSpeaker.position.set(this.models.windowSpeaker.position.x, this.models.windowSpeaker.position.y, this.models.windowSpeaker.position.z)
        this.windowSpeaker.add(this.windowRain)

        this.windowRain2 = new THREE.PositionalAudio( this.listener )
        this.windowRain2.setBuffer(this.resources.items.windowRain)
        this.windowRain2.setRefDistance(0.3)
        this.windowRain2.setRolloffFactor(2)
        this.windowRain2.setLoop(true)
        this.windowRain2.setVolume(1.2)

        this.windowSpeaker2 = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.windowSpeaker2)
        this.windowSpeaker2.position.set(this.models.windowSpeaker2.position.x, this.models.windowSpeaker2.position.y, this.models.windowSpeaker2.position.z)
        this.windowSpeaker2.add(this.windowRain2)

        this.drip = new THREE.PositionalAudio( this.listener )
        this.drip.setBuffer(this.resources.items.drip)
        this.drip.setRefDistance(0.1)
        this.drip.setRolloffFactor(2)
        this.drip.setLoop(true)
        this.drip.setVolume(1.4)

        this.dripSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.dripSpeaker)
        this.dripSpeaker.position.set(this.models.dripSpeaker.position.x, this.models.dripSpeaker.position.y, this.models.dripSpeaker.position.z)
        this.dripSpeaker.add(this.drip)

        this.clock = new THREE.PositionalAudio( this.listener )
        this.clock.setBuffer(this.resources.items.clock)
        this.clock.setRefDistance(0.2)
        this.clock.setRolloffFactor(1)
        this.clock.setLoop(true)
        this.clock.setVolume(1.2)

        this.clockSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.clockSpeaker)
        this.clockSpeaker.position.set(this.models.clockSpeaker.position.x, this.models.clockSpeaker.position.y, this.models.clockSpeaker.position.z)
        this.clockSpeaker.add(this.clock)

        this.static = new THREE.PositionalAudio( this.listener )
        this.static.setBuffer(this.resources.items.static)
        this.static.setRefDistance(0.05)
        this.static.setRolloffFactor(3)
        this.static.setLoop(true)
        this.static.setVolume(5)

        this.staticSpeaker = new THREE.Mesh( this.speakerGeo, this.speakerMat )
        this.scene.add(this.staticSpeaker)
        this.staticSpeaker.position.set(this.models.staticSpeaker.position.x, this.models.staticSpeaker.position.y, this.models.clockSpeaker.position.z)
        this.clockSpeaker.add(this.clock)

        this.camera.add( 
            this.listener, 
            this.rain, 
            this.footstep1, 
            this.footstep2, 
            this.footstep3,
            this.footstep4,
            this.bootUp 
        )
    }

    play(sound)
    {
        eval("this." + sound + ".play()")
    }

    pause(sound)
    {
        eval("this." + sound + ".stop()")
    }

    beginAudio()
    {
        gsap.delayedCall(1, () =>
        {
            this.wood.play()
            // this.water.play()
            this.windowRain.play()
            this.windowRain2.play()
            this.drip.play()
            this.clock.play()
            this.static.play()
        })
    }

    masterVolumeOn()
    {
        gsap.to(this.params, {masterVolume: 0.7, duration:2, onComplete: () => {this.audioChanging = false}}).play()
        this.audioChanging = true
    }

    masterVolumeOff()
    {
        gsap.to(this.params, {masterVolume: 0, duration:2, onComplete: () => {this.audioChanging = false}}).play()
        this.audioChanging = true
    }

    update()
    {
        if(this.audioChanging === true)
        {
            this.listener.setMasterVolume(this.params.masterVolume)
        }
    }

    /**------------------------------------------------------------------
     *--------------------------------DEBUG------------------------------
     *-------------------------------------------------------------------
    */

    setDebug()
    {
        if(this.debug.active)
        {
            this.debugFolder = this.debug.audioDebugFolder
            this.debugFolder.add(this.params, 'masterVolume', 0, 1).onChange(() =>
            {
                this.listener.setMasterVolume(this.params.masterVolume)
            })
            this.debugFolder.close()
        }
    }
}